var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { ProposalItemComponent } from '@popup/steem/pages/app-container/home/governance/proposal-tab/proposal-item/proposal-item.component';
import ProposalUtils from '@popup/steem/utils/proposal.utils';
import ProxyUtils from '@popup/steem/utils/proxy.utils';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
import RotatingLogoComponent from 'src/common-ui/rotating-logo/rotating-logo.component';
const ProposalTab = ({ activeAccount, globalProperties }) => {
    const [proposals, setProposals] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [displayingProxyVotes, setDisplayingProxyVotes] = useState(false);
    useEffect(() => {
        initList();
    }, []);
    const initList = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        let proposals;
        let proxy = yield ProxyUtils.findUserProxy(activeAccount.account);
        if (proxy) {
            setDisplayingProxyVotes(true);
        }
        else {
            setDisplayingProxyVotes(false);
        }
        proposals = yield ProposalUtils.getProposalList(proxy !== null && proxy !== void 0 ? proxy : activeAccount.name, globalProperties.globals);
        setProposals(proposals);
        setLoading(false);
    });
    const toggleVoteInArray = (id) => {
        const proposalsCopy = [...proposals];
        for (let proposal of proposalsCopy) {
            if (proposal.proposalId === id) {
                proposal.voted = !proposal.voted;
                break;
            }
        }
        setProposals(proposalsCopy);
    };
    return (React.createElement("div", { "data-testid": "proposal-tab", className: `proposal-tab ${isLoading ? 'loading' : ''}` },
        !isLoading && (React.createElement(React.Fragment, null,
            displayingProxyVotes && (React.createElement("div", { className: "using-proxy" }, getMessage('html_popup_currently_using_proxy', [
                activeAccount.account.proxy,
            ]))),
            React.createElement("div", { className: "proposal-list" }, proposals.map((proposal) => (React.createElement(ProposalItemComponent, { key: proposal.proposalId, proposal: proposal, onVoteUnvoteSuccessful: () => toggleVoteInArray(proposal.id) })))))),
        isLoading && (React.createElement("div", { className: "loading-panel" },
            React.createElement(RotatingLogoComponent, null)))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
        globalProperties: state.steem.globalProperties,
    };
};
const connector = connect(mapStateToProps, {});
export const ProposalTabComponent = connector(ProposalTab);
